var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('prism',{staticClass:"prism",class:[
    { 'prism--fixed': _vm.fixed },
    { 'prism--bottom': _vm.bottom },
    { 'prism--left': _vm.left },
    { 'prism--right': _vm.right },
    { 'prism--top': _vm.top } ],attrs:{"language":_vm.language}},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }